import { get_axios_instance, api_variables,errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_FBP_SETTINGS);
var axios_instance_fbcomponents= get_axios_instance(api_variables.SERVICE_FBP_COMPONENTS);

// const _pk_name = "id";

const state = {
  data:{},
};

const mutations = {
    fbpsettings: (state, payload) => {
    state.data = payload;
    //console.log('state data', state.data);
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  set: (state, [payload, id]) => {
    state.data[id] = payload;
  },
}

const actions = {
  async create({commit}, payload) {
      //console.log("[state/organisation/utility/fbpsettings/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/organisation/utility/fbpsettings/create] res: ", res.data.payload.data);
      if(res.status == 200) {
        commit("fbpsettings", payload);
      }
      return res;
    }catch(err) {
      //console.log(err)
      throw errorHandler(err.response);
    }
  },
  async fetchAllcomponents({ commit },payload) {
    //console.log("[state/onboard/fetchallfbpcomponents/fetchAll] Calling API...");
    try {
      // commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: {
          //le_id:"01d1f236-afd7-4422-9ee9-ea88587f4b1f"
          le_id:payload
        }
      });  
      // commit("setFetching", false);
      //console.log("[state/onboard/employees/fetchAll] res:",res);
      if (res.status == 200) {
        //  commit("set", res.payload.data);
        // //console.log('res components',res)
      }
      return res;
    } catch (err) {
      //console.log(err);
      if(err.response){
      throw errorHandler(err.response);
      }
    }
  },

  async updateComponent({commit}, payload){
    //console.log("[state/onboard/updatefbpcomponent] Calling API...");
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(``, payload);  
      commit("setSaving", false);
      //console.log("[state/onboard/updatefbpcomponent] res:",res);
      if (res.status == 200) {
        // commit("set", res.data.payload);
        //console.log('res components',res)
      }
      return res;
    } catch (err) {
      //console.log(err);
      if(err.response){
      throw errorHandler(err.response);
      }
    }
  }
}

export default {
  namespaced: true,
  state, mutations, actions
}
